import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol, PageFeatureConfigSymbol, Fetch, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import type { Experiments, ModuleLoader } from '@wix/thunderbolt-symbols'
import { ESMLoaderSymbol } from 'feature-builder-module-loader'

import type {
	BuilderContextProvidersSiteConfig,
	BuilderContextProvidersPageConfig,
	ContextProviderLoader,
	ContextProviderRegistry,
} from './types'
import { ContextProviderRegistrySymbol, name } from './symbols'

export const BuilderContextProvidersLoader = withDependencies(
	[
		named(SiteFeatureConfigSymbol, name),
		named(PageFeatureConfigSymbol, name),
		ESMLoaderSymbol,
		ContextProviderRegistrySymbol,
		ExperimentsSymbol,
	],
	(
		siteFeatureConfig: BuilderContextProvidersSiteConfig,
		pageFeatureConfig: BuilderContextProvidersPageConfig,
		moduleLoader: ModuleLoader,
		contextProviderRegistry: ContextProviderRegistry,
		experiments: Experiments
	): ContextProviderLoader => {
		return {
			retrieveContextProviders: async (compId: string) => {
				if (!experiments['specs.thunderbolt.contextProviders']) {
					return
				}

				const contexts = pageFeatureConfig.compIdToContextsMap[compId] || []
				await Promise.all(
					contexts.map(async (context) => {
						const { contextType } = context
						const contextProviderData = siteFeatureConfig.contextProviders[contextType]
						const urlToLoad =
							process.env.PACKAGE_NAME === 'thunderbolt-ds'
								? contextProviderData.editorComponentUrl || contextProviderData.componentUrl
								: contextProviderData.componentUrl

						const contextProviderModule = await moduleLoader.loadModule(urlToLoad)
						contextProviderRegistry.registerContextProvider(contextType, contextProviderModule)
					})
				)
			},
		}
	}
)
